export class AuditQuery {
  constructor({ entity = null, fromDate = null, toDate = null } = {}) {
    this.entity = entity;
    this.fromDate = fromDate;
    this.toDate = toDate;
  }
}
export function createAuditQuery(data) {
  return Object.freeze(new AuditQuery(data));
}
